import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Link } from 'react-router'
import configpath from 'configpath'

import Styles from './index.scss'

const Item = (props) => {
  const host = configpath.wisp_public_url
  let title = ''
  const numberTitle = props.index + 1
  if (props.index + 1 < 10) {
    title = `Pitch 00${numberTitle}`
  } else if (props.index + 1 >= 10 && props.index < 100) {
    title = `Pitch 0${numberTitle}`
  } else {
    title = `Pitch ${numberTitle}`
  }
  const pitchLink = `/projects/${props.order.id}/pitch/${props.id}`
  const projectInvitationLink = `${host}/${props.profile.profileId}/project/${props.order.id}`
  return (
    <div className={`${Styles['item-box']}`}>
      <span className={`${Styles['item-title']}`}>{title}</span>
      <div className={`${Styles['item-container']}`}>
        <div className={`${Styles.content}`}>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Name</span>
            <span className={`${Styles['item-value']}`}>
              <Link to={`/profiles/${props.profile.profileId}`}>
                {props.profile.name}
              </Link>
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Service Type</span>
            <span className={`${Styles['item-value']}`}>
              {`${props.order_detail.serviceName} ${props.order_detail.formatName}`}
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>QTY</span>
            <span className={`${Styles['item-value']}`}>{props.quantity}</span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Estimated Views</span>
            <span className={`${Styles['item-value']}`}>
              { props.viewers
                ? <NumberFormat
                  thousandSeparator
                  displayType="text"
                  value={props.viewers}
                />
                : '-'
              }
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>CPV</span>
            <span className={`${Styles['item-value']}`}>{props.cpv}</span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Total Client Price</span>
            <span className={`${Styles['item-value']}`}>
              <NumberFormat
                thousandSeparator
                displayType="text"
                value={props.totalClientPrice}
              />
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Pay To Creator</span>
            <span className={`${Styles['item-value']}`}>
              <NumberFormat
                thousandSeparator
                displayType="text"
                value={props.payToCreator}
              />
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Pitch Status</span>
            <span className={`${Styles['item-value']}`}>{props.statusLabel}</span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Email</span>
            <span className={`${Styles['item-value']}`}>{props.user.email}</span>
          </div>
        </div>
        <div className={`${Styles.content}`}>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Phone No.</span>
            <span className={`${Styles['item-value']}`}>{props.user.phoneNumber}</span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Po No.</span>
            <span className={`${Styles['item-value']}`}>
              {props.poExist ?
                <Link to={props.purchaseOrder.url} target="_blank">
                  {props.purchaseOrder.poNumber}
                </Link>
                : '-'
              }
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Pitch Link</span>
            <span className={`${Styles['item-value']}`}>
              <Link to={`/projects/${props.order.id}/pitch/${props.id}`}>
                {`${pitchLink.substring(0, 30)}...`}
              </Link>
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Project Invitation Link</span>
            <span className={`${Styles['item-value']}`}>
              <Link to={`${host}/${props.profile.profileId}/project/${props.order.id}`}>
                {`${projectInvitationLink.substring(0, 30)}...`}
              </Link>
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Creative Idea</span>
            <span className={`${Styles['item-value']}`}>
              <div dangerouslySetInnerHTML={{ __html: props.idea }} />
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Bank Name</span>
            <span className={`${Styles['item-value']}`}>
              {props.infoExist
                ? props.profileBank.bank.name
                : <span className="italic">No Bank Info Provided</span>
              }
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Bank Account</span>
            <span className={`${Styles['item-value']}`}>
              {props.infoExist
                ? props.profileBank.accountNumber
                : <span className="italic">No Bank Info Provided</span>
              }
            </span>
          </div>
          <div className={`${Styles.item}`}>
            <span className={`${Styles['item-label']}`}>Creator's Registered Name in Bank</span>
            <span className={`${Styles['item-value']}`}>
              {props.infoExist
                ? props.profileBank.accountName
                : <span className="italic">No Bank Info Provided</span>
              }
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

Item.propTypes = {
  profile: PropTypes.shape({
    profileId: PropTypes.string,
    name: PropTypes.name,
  }).isRequired,
  order_detail: PropTypes.shape({
    serviceName: PropTypes.string,
    formatName: PropTypes.string,
  }).isRequired,
  quantity: PropTypes.number.isRequired,
  viewers: PropTypes.number.isRequired,
  cpv: PropTypes.string.isRequired,
  totalClientPrice: PropTypes.number.isRequired,
  statusLabel: PropTypes.string.isRequired,
  payToCreator: PropTypes.number.isRequired,
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
  }).isRequired,
  poExist: PropTypes.bool.isRequired,
  purchaseOrder: PropTypes.shape({
    url: PropTypes.string,
    poNumber: PropTypes.string,
  }).isRequired,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.string.isRequired,
  idea: PropTypes.string.isRequired,
  infoExist: PropTypes.bool.isRequired,
  profileBank: PropTypes.shape({
    bank: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    accountNumber: PropTypes.string.isRequired,
    accountName: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
}

export default Item
